export default __webpack_public_path__ + "static/media/collapsed-disabled.213a5339.svg";